// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__qKnu4","footer__second-child":"Footer_footer__second-child__siuW-"};